import { FooterBrand } from "@/components/Layout/footer/FooterBrand";
import { FooterContacts } from "@/components/Layout/footer/FooterContacts";
import { FooterLegal } from "@/components/Layout/footer/FooterLegal";
import { FooterNavigation } from "@/components/Layout/footer/FooterNavigation";
import "./Footer.css";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <FooterBrand />
        <FooterNavigation />
        <FooterContacts />
        <FooterLegal />
      </div>
    </footer>
  );
}
